import FindInPageOutlinedIcon from '@mui/icons-material/FindInPageOutlined';
import MacieDetailBody from '../MacieDetailBody';

// Descriptor for the Macie engine — the 4th Security Hub capability. Same shape
// as cspm.js / guardduty.js; registering it in registry.js auto-wires the
// sidebar, Overview, EnableCapabilities panel, and unified findings inbox.
export const macieEngine = {
  id: 'macie',
  label: 'Amazon Macie',
  color: '#0d9488',
  Icon: FindInPageOutlinedIcon,
  capability: {
    name: 'Data security',
    source: 'macie',
    description: 'S3 data-security posture and sensitive-data findings across your accounts.',
    items: ['S3 bucket posture', 'Policy findings', 'Sensitive-data findings', 'Automated discovery (opt-in)'],
  },
  // sidebar sub-items shown under "Detection engines → Amazon Macie"
  nav: [
    { label: 'Dashboard', to: '/securityhub/macie' },
    { label: 'S3 buckets', to: '/securityhub/macie/buckets' },
    { label: 'Findings', to: '/securityhub/macie/findings' },
    { label: 'Enrollment', to: '/securityhub/macie/enrollment' },
    { label: 'Settings', to: '/securityhub/macie/settings' },
  ],
  enableRoute: '/securityhub/macie', // where "Enable/Configure" routes
  DetailBody: MacieDetailBody,
};
